export interface FileInfo {
  name: string;
  data64: string;
  size?: number;
}

export const DateFormat = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

export interface Diagnosis {
  id: string;
  name: string;
  category: string;
  displayName: string;
  showAdditionalInformation: boolean;
  additionalInformationRequired: boolean;
  translations: {
    en: string;
    de: string;
    fr: string;
    it: string;
  }
}

export interface DiagnosisCategory {
  name: string;
  displayName: string;
  translations: {
    en: string;
    de: string;
    fr: string;
    it: string;
  }
  values: Diagnosis[];
}

export interface DiagnosisDTO {
  id: string;
  category: string;
}

export type FnolSubmissionStatus = 'RECEIVED' | 'PROCESSING' | 'COMPLETED' | 'FAILED';

/**
 * Body of a successful `POST /fnol`: `202` for a new submission, `200` with
 * `duplicate: true` when the same data was sent before.
 */
export interface FnolSubmissionResponse {
  submissionId: string;
  status: FnolSubmissionStatus;
  duplicate?: boolean;
}
